import React, { Component } from 'react';

class DaniHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {  }
  }
  render() { 
    let {trivvysGenerated} = this.props
    return ( 
      <div className="dani-header"
        style={{
          backgroundColor: trivvysGenerated? '#d4edda':''
        }}
      >
        {this.props.children}
      </div>
    );
  }
}
 
export default DaniHeader;